export default {
  namespaced: true,
  state: {
    imgList: [],
    imgDetail: {}
  },
  mutations: {
    SET_IMG_LIST (state, list) {
      state.imgList = list
    },
    SET_IMG_DETAIL (state, detail) {
      state.imgDetail = detail
    }
  }
}
